var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 12,
    r: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1777 1.52344C16.6244 1.15861 17.2546 1.1585 17.7012 1.52344L17.7939 1.60742L17.8184 1.63379L22.4609 6.72266H22.46C22.6532 6.92994 22.7089 7.17204 22.7285 7.28906C22.7517 7.42771 22.75 7.55552 22.75 7.59766C22.75 7.74645 22.7449 8.17482 22.3623 8.57031L22.3633 8.57129L17.7207 13.5674C17.7143 13.5743 17.7079 13.5812 17.7012 13.5879C17.5684 13.7202 17.4128 13.7898 17.3174 13.8252C17.2047 13.8669 17.0789 13.8964 16.9492 13.9082C16.718 13.9291 16.3102 13.9048 15.9922 13.5879C15.9352 13.5311 15.8877 13.4655 15.8516 13.3936C15.7824 13.2557 15.7327 13.1219 15.7051 12.9844C15.6775 12.8466 15.6787 12.7339 15.6787 12.6865V10.7109C13.2375 11.0334 11.1029 12.8895 10.665 15.1426C10.6122 15.4146 10.4134 15.6355 10.1484 15.7168C9.88357 15.798 9.59569 15.7268 9.39941 15.5312C9.04523 15.1783 8.76672 14.6089 8.58008 14.0635C8.38619 13.4968 8.25006 12.8349 8.25 12.2246C8.25 8.21147 11.8023 4.95015 15.6787 4.57129V2.60156C15.6787 2.53566 15.6713 2.33791 15.7402 2.13184C15.8156 1.90672 15.9517 1.74018 16.085 1.60742L16.1777 1.52344Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 4,
    r: 1,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 2,
    r: 2,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 16.5,
    r: 1.5,
    fill: "currentColor"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 11.5,
    r: 0.5,
    fill: "currentColor"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 0.5,
    r: 0.5,
    fill: "currentColor"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 1,
    r: 1,
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.24337b74a245d658ca0fa3b201e95721.svg";
export { ForwardRef as ReactComponent };